module.exports = __webpack_public_path__ + "static/media/droneOffline.f36586c7.png";